export default __webpack_public_path__ + "static/media/okra.adb15162.jpg";